import { FunctionComponent, PropsWithChildren } from 'react';

import {
  FormControl,
  FormControlLabel,
  FormLabel,
  Radio,
  RadioGroup,
} from '@mui/material';

import { setRadioGroupCheckedValue } from '../../../../utils/set-radio-group-checked-value/set-radio-group-checked-value.util';
import { BasicInfoFormikModel } from '../../models/basic-info-formik.model';
import { BasicInfoComponentProps } from '../../types/basic-info-component.props';
import { FotaUpdateTypeEnum } from './enum/fota-update-type.enum';
import { fotaUpdateTypes } from './utils/fota-update-types.util';

export const FotaUpdateTypeRadioGroupInput: FunctionComponent<
  BasicInfoComponentProps
> = (props: PropsWithChildren<BasicInfoComponentProps>) => {
  const { values, setFieldValue, handleBlur } = props;

  const setCheckedValue = setRadioGroupCheckedValue<BasicInfoFormikModel>(
    setFieldValue,
    'fotaUpdateType'
  );

  return (
    <FormControl
      data-testid="fota-update-type-form-input-form-control"
      className="not-centered radio-button-control"
    >
      <FormLabel
        id="fota-update-type"
        sx={{ color: theme => theme.palette.black.main }}
        required={true}
        classes={{ focused: 'label-focused' }}
      >
        FOTA Update Type
      </FormLabel>

      <RadioGroup
        row
        aria-labelledby="fota-update-type"
        name="fotaUpdateType"
        value={values.fotaUpdateType ?? FotaUpdateTypeEnum.REGULAR}
        onChange={setCheckedValue}
        onBlur={handleBlur}
      >
        {fotaUpdateTypes.map(option => (
          <FormControlLabel
            className="radio-button-label"
            key={option.value}
            value={option.value}
            label={option.label}
            control={
              <Radio
                classes={{
                  root: 'radio-button-container',
                }}
                className="radio-button"
                data-testid={`${option.label}-option`}
                checked={values.fotaUpdateType === option.value}
              />
            }
          />
        ))}
      </RadioGroup>
    </FormControl>
  );
};
